import React from 'react';
import { Check } from 'lucide-react';

const tiers = [
  {
    name: 'Starter',
    price: '150',
    features: [
      'Up to 10 Users',
      'Doctor Database',
      'Visit Planning & Reporting',
      'Basic Analytics',
    ],
    cta: 'Contact Sales',
  },
  {
    name: 'Professional',
    price: '200',
    features: [
      'Up to 50 Users',
      'All Starter Features',
      'Expense Management',
      'Route Optimizer',
      'Advanced Analytics',
    ],
    cta: 'Get Started',
    featured: true,
  },
  {
    name: 'Enterprise',
    price: 'Contact Us',
    features: [
      'Unlimited Users',
      'All Professional Features',
      'Live Team Tracking',
      'Custom Integrations',
      'Dedicated Support',
    ],
    cta: 'Contact Sales',
  },
];

export default function PricingSection({ onSubscribeClick }) {
  return (
    <section className="py-16 bg-white md:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            Find the Right Plan for Your Team
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Simple, transparent pricing. No hidden fees.
          </p>
        </div>
        <div className="grid gap-8 mt-12 md:grid-cols-2 lg:grid-cols-3">
          {tiers.map((tier) => (
            <div key={tier.name} className={`border rounded-xl p-8 flex flex-col ${tier.featured ? 'border-blue-600 border-2 shadow-2xl' : 'border-gray-200'}`}>
              <h3 className="text-2xl font-semibold text-gray-900">{tier.name}</h3>
              <div className="mt-4">
                {tier.price === 'Contact Us' ? (
                  <p className="text-4xl font-bold text-gray-900">{tier.price}</p>
                ) : (
                  <p className="text-4xl font-bold text-gray-900">
                    ₹{tier.price}
                    <span className="text-base font-medium text-gray-500">/user/month</span>
                  </p>
                )}
              </div>
              <p className="mt-6 text-gray-600">Includes:</p>
              <ul className="flex-grow mt-4 space-y-3">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex space-x-3">
                    <Check className="flex-shrink-0 w-5 h-5 text-green-500" aria-hidden="true" />
                    <span className="text-base text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <button
                className={`mt-8 w-full py-2 px-6 rounded-lg font-semibold text-md transition-colors ${tier.featured
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-gray-800 hover:bg-gray-900 text-white'
                  }`}
                onClick={() => onSubscribeClick(tier.name)}
              >
                {tier.cta}
              </button>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-center text-gray-500">
          Need a custom solution? All plans are fully customizable.
        </p>
      </div>
    </section>
  );
}
